import { WStateLayout } from '@wareclouds/wareclouds-ui';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { useTranslation } from 'react-i18next';

export default function NotFoundLayout() {
  const { t } = useTranslation(['title']);

  return (
    <WStateLayout
      description={t('page_not_found', { ns: 'title' })}
      title={'ERROR 404'}
      sxTitleStyles={{
        fontSize: '20px',
        color: 'primary.main',
        fontWeight: 'bold',
      }}
      sxDescriptionStyles={{
        fontSize: '28px',
        color: 'text.secondary',
      }}
    >
      <SentimentVeryDissatisfiedIcon
        sx={{ fontSize: '200px' }}
        color="disabled"
      />
    </WStateLayout>
  );
}
